import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field"
export default class extends Controller {
  static targets = ['input']
  static values = { kind: String }

  connect() {
    if (this.hasKindValue) {
      switch (this.kindValue) {
        case 'select-description':
          this.inputTarget.dataset.action = 'field#selectDescription'

          this.selectDescription();
          break;
      }
    }
  }

  selectDescription() {
    this.element.querySelector('span.description').innerHTML = this.inputTarget.options[this.inputTarget.selectedIndex].dataset.description;
  }
}
